import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { actions } from '../../modules/Actions';
import { DEFAULT_PAGE_VIEW, DEFAULT_SCROLL_INFO, SORT_TYPE } from '../../../Common';

export interface FilterLinkedDataState extends FilterConditionLinkedDataState {
  page: number;
  order: string;
  from: number;
  apiUpdateIndex: number;
}
export interface FilterConditionLinkedDataState {
  fromDate: string;
  toDate: string;
  mobile: string[];
  internet: string[];
  electric: string[];
}

export type FilterLinkedDataStateBase = Omit<FilterLinkedDataState, 'page'>;

export const initialFilterLinkedDataState: FilterLinkedDataState = {
  fromDate: '',
  toDate: '',
  mobile: [],
  internet: [],
  electric: [],
  page: DEFAULT_PAGE_VIEW.CURRENT_PAGE,
  order: SORT_TYPE.CREATE_DATE_DESC,
  from: DEFAULT_SCROLL_INFO.FROM,
  apiUpdateIndex: DEFAULT_PAGE_VIEW.API_UPDATE_INDEX,
};

export const FilterLinkedDataReducer = reducerWithInitialState(initialFilterLinkedDataState)
  .case(actions.filterLinkedData.updateFilterCondition, (state: FilterLinkedDataState, payload: FilterConditionLinkedDataState) => {
    return { ...state, ...payload };
  })
  .case(actions.filterLinkedData.updateSortInfo, (state: FilterLinkedDataState, payload: string) => {
    return { ...state, order: payload };
  })
  .case(actions.filterLinkedData.updateCurrentPage, (state: FilterLinkedDataState, payload: number) => {
    return { ...state, page: payload };
  })
  .case(actions.filterLinkedData.updateScrollInfo, (state: FilterLinkedDataState, payload: number) => {
    return { ...state, from: payload };
  })
  .case(actions.filterLinkedData.updateApiIndexValue, (state: FilterLinkedDataState, payload: number) => {
    return { ...state, apiUpdateIndex: payload };
  });
